<section class="wrapper">
    <section>
    <rappider-list-grid [config]="listGridConfig"
                        [data]="activeEntityData"
                        [loading]="false"
                        (selectionChange)="onSelectionChange($event)"></rappider-list-grid>
    </section>
    <section class="selected-objects">
        <rappider-list-grid [config]="listGridSelectedConfig"
                            [data]="activeEntityDataSelected"
                            [loading]="false"></rappider-list-grid>
    </section>
    <section>
        <section>
            <rappider-markdown-viewer [markdownText]="salesforceSelectedObjectsContent"></rappider-markdown-viewer>
        </section>
        <section class="frequency-wrapper">
            <rappider-alert [type]="salesforceInfoAlertConfig.type"
                            [title]="salesforceInfoAlertConfig.title"
                            [description]="salesforceInfoAlertConfig.description"
                            [closeable]="salesforceInfoAlertConfig.closeable"
                            [showIcon]="salesforceInfoAlertConfig.showIcon"></rappider-alert>
            <div class="frequency-select">
                <rappider-paragraph [content]="'Select Frequency:'"
                                    [colorSettings]="'var(--text-color)'"
                                    [typography]="{fontWeight:'bold'}"></rappider-paragraph>
                <rappider-select [(ngModel)]="frequency"
                                    [options]="frequencyConfig"
                                    (ngModelChange)="frequencyChange($event)"></rappider-select>
            </div>

        </section>
        <rappider-button [text]="'Save & Sync'"
                         [size]="fileListButton.fileListButtonIcon.size"
                         [customColorSettings]="selectedItem ? fileListButton.fileListButtonIcon.customColorSettings : null"
                         [disabled]="!selectedItem"
                         [tooltipText]="!selectedItem ? 'Please select an item' : null"
                         [borderSettings]="selectedItem ? fileListButton.fileListButtonIcon.borderSettings : null"
                         (click)="fileListButtonClick()"></rappider-button>
    </section>
</section>
